import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Card } from './Card';
export const CardWithTitle = (_a) => {
    var { children, subtitle, title, titleAs } = _a, otherProps = __rest(_a, ["children", "subtitle", "title", "titleAs"]);
    return (_jsx(Card, Object.assign({ pb: 6, pl: 6, pr: 6, pt: 4 }, otherProps, { children: _jsxs(SectionWrapper, { children: [_jsxs(Header, { as: titleAs, children: [title, subtitle && (typeof subtitle === 'string' ? (_jsx(Box, { font: "body-regular-dove", children: subtitle })) : (subtitle))] }), children] }) })));
};
const Header = styled(Box).attrs({
    alignItems: 'center',
    font: 'h3-semibold',
    justifyContent: 'space-between',
    pb: 5,
}) ``;
const SectionWrapper = styled(Box).attrs({
    flexDirection: 'column',
}) ``;
//# sourceMappingURL=CardWithTitle.js.map